module.exports = __webpack_public_path__ + "img/aboutIMG.8a4ad7d6.png";